import React, { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Checkbox } from 'antd';
import { DAY_FORMAT, ORDER_STATUSES } from '../../../constants';
import './OrderForm.scss';
import OptionalLabel from '../../Elements/OptionalLabel';

import dayjs from 'dayjs';

const OrderForm = ({ form, order, limitedFields }) => {
  const [expected, setExpected] = useState(order?.status === ORDER_STATUSES.EXPECTED);
  const futureDeliveryDate =
    !order?.id && !expected
      ? {
          type: 'date',
          min: dayjs().startOf('day').toDate().getTime(),
          message: 'Please use a date in the future',
        }
      : null;

  const checkExpected = (v) => {
    if (v.target.checked) {
      setExpected(true);
      form.setFieldValue('status', ORDER_STATUSES.EXPECTED);
      form.setFieldValue('deliveryDate', null);
    } else {
      setExpected(false);
      form.setFieldValue('status', null);
    }
  };

  useEffect(() => {
    if (order?.status) setExpected(order.status === ORDER_STATUSES.EXPECTED);
  }, [order]);
  return (
    <div className={`OrderForm`}>
      <Row gutter={24}>
        <Col span={5}>
          <Form.Item label="Order Ref" name="orderRef" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Order Ref" size="large" />
          </Form.Item>
        </Col>
        <Col span={2}>
          <Form.Item label="Expected" name="status">
            <Checkbox onChange={checkExpected} checked={expected}></Checkbox>
          </Form.Item>
        </Col>
        <Col span={5}>
          <Form.Item
            name="deliveryDate"
            label="Delivery Date"
            rules={[{ required: true, message: 'Required' }, futureDeliveryDate]}
          >
            <DatePicker size="large" format={DAY_FORMAT} minDate={dayjs()} disabled={expected} />
          </Form.Item>
        </Col>
        {/* <Col span={5}>
          <Form.Item name="load" label="Load" rules={[{ required: !limitedFields, message: 'Required' }]}>
            <Input min={1} type="number" placeholder="Load" size="large" disabled={limitedFields} />
          </Form.Item>
        </Col> */}

        <Col span={7}>
          <Form.Item name="name" label="Name">
            <Input placeholder="Name" size="large" />
          </Form.Item>
        </Col>
        {order && (
          <Col span={5}>
            <Form.Item name="status" label="Status" rules={[{ required: !limitedFields, message: 'Required' }]}>
              <Select
                options={Object.keys(ORDER_STATUSES).map((key) => ({ value: key, label: ORDER_STATUSES[key] }))}
                size="large"
                placeholder="Order Status"
                disabled={limitedFields}
              />
            </Form.Item>
          </Col>
        )}
        <Col span={12}>
          <Form.Item name="description" label={<OptionalLabel title="Description" />}>
            <Input placeholder="Description" size="large" />
          </Form.Item>
        </Col>
        {order && (
          <Col span={6}>
            <Form.Item name="attempt" label={<OptionalLabel title="Attempts" />}>
              <Input min={0} type="number" placeholder="Attempts" size="large" disabled={limitedFields} />
            </Form.Item>
          </Col>
        )}

        {/* <Col span={3}>
          <Form.Item name="sizeLength" label="Size (LxWxH)">
            <Input min={1} type="number" size="large" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name="sizeWidth" label={<OptionalLabel title=" " />}>
            <Input min={1} type="number" size="large" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name="sizeHeight" label={<OptionalLabel title=" " />}>
            <Input min={1} type="number" size="large" suffix="cm" />
          </Form.Item>
        </Col>
        <Col span={3}>
          <Form.Item name="weight" label={<OptionalLabel title="Weight" />}>
            <Input min={1} type="number" size="large" suffix="kg" />
          </Form.Item>
        </Col> */}
        <Col span={12}></Col>
        <Col span={12}>
          {/* <Form.Item label={<OptionalLabel title="Type" />} name="types">
            <TagInput
              size="large"
              tags={types}
              onChange={(values) => !limitedFields && setTypes(values)}
              disabled={limitedFields}
            />
          </Form.Item> */}
        </Col>
        <Col span={24}>
          <Form.Item label={<OptionalLabel title="Support Note" />} name="supportNote">
            <Input placeholder="Support Note" size="large" disabled={limitedFields} />
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default OrderForm;
